import { render, staticRenderFns } from "./Implantar.vue?vue&type=template&id=77e9ade3&lang=pug&"
import script from "./Implantar.vue?vue&type=script&lang=js&"
export * from "./Implantar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports